import { Case } from "generated/graphql";
import { HeaderCard, HeaderCardTitle } from "components/HeaderCard";
import SBR from "./SBR";
import { useAppSelector } from "redux/hooks";
import { selectSectionValues } from "redux/slices/case";
import { selectFormId, selectOutcomeEnabledFormSections } from "redux/slices/form.slice";

export default function SBRCaseActions({ lensCase }: { lensCase: Case }) {
  const sectionValues = useAppSelector(selectSectionValues);
  const formSections = useAppSelector(selectOutcomeEnabledFormSections);
  const formId = useAppSelector(selectFormId);

  return (
    <HeaderCard title={<HeaderCardTitle title="Review Progress" />}>
      {formId !== undefined && (
        <SBR lensCase={lensCase} sectionValues={sectionValues} formSections={formSections} formId={formId} />
      )}
    </HeaderCard>
  );
}
